import { FormattedMessage } from '@alltrails/shared/react-intl';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '../../../../utils/language_support_util';
import GiftingBlockBase from '../GiftingBlockBase';
import smallAvifSrc from './gift-card-w590.avif';
import smallWebpSrc from './gift-card-w590.webp';
import smallJpgSrc from './gift-card-w590.png';
import largeAvifSrc from './gift-card-w1388.avif';
import largeWebpSrc from './gift-card-w1388.webp';
import largeSrc from './gift-card-w1388.png';

export default function GenericGiftingBlock() {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <GiftingBlockBase
      imgSrc={largeSrc}
      smallAvifSrc={smallAvifSrc}
      smallWebpSrc={smallWebpSrc}
      smallSrc={smallJpgSrc}
      largeAvifSrc={largeAvifSrc}
      largeWebpSrc={largeWebpSrc}
      title={<FormattedMessage defaultMessage="Give the gift of adventure" />}
      subtext={
        <FormattedMessage defaultMessage="Celebrate the nature lovers in your life with a whole year of offline maps, wrong-turn alerts, and lots more." />
      }
      ctaText={<FormattedMessage defaultMessage="Give AllTrails+" />}
      ctaLink={wrapUrlSafe('/gift?ref=homepage_gift_genericgiftingblock', languageRegionCode)}
    />
  );
}
